"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAmountFromDecimal = exports.newAmountFromBigNumber = void 0;
const amount_pb_1 = require("./amount_pb");
const num_1 = require("../num");
const network_1 = require("./network");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
/**
 * Creates a new FutureAmount object using a BigNumber and a Token.
 *
 * @param {BigNumber} amount - The amount in BigNumber format to be converted to Decimal.
 * @param {FutureToken} token - The token type that the amount is denominated in.
 * @returns {FutureAmount} Returns an Amount object that contains the value in Decimal format and the type of token.
 *
 * @remarks
 * This function leverages the bigNumberToDecimal function to convert the BigNumber amount into a Decimal object.
 * The resulting Decimal object and the provided Token are then used to construct and return a new Amount object.
 * NOTE: this performs the necessary truncation so that the resultant amount contains a valid number of
 * decimal places for the target network.
 */
function newAmountFromBigNumber(amount, token) {
    return new amount_pb_1.FutureAmount()
        .setValue((0, num_1.bigNumberToDecimal)(amount.decimalPlaces((0, network_1.getNetworkNoDecimalPlaces)(token.getNetwork()), bignumber_js_1.default.ROUND_HALF_DOWN)))
        .setToken(token);
}
exports.newAmountFromBigNumber = newAmountFromBigNumber;
/**
 * Creates a new FutureAmount object using a Decimal and a Token.
 *
 * @param {Decimal} amount - The amount in Decimal format to be converted to Decimal.
 * @param {FutureToken} token - The token type that the amount is denominated in.
 * @returns {FutureAmount} Returns an Amount object that contains the value in Decimal format and the type of token.
 *
 * @remarks
 * This function leverages the bigNumberToDecimal function to convert the Decimal amount into a BigNumber object.
 * The resulting Decimal object and the provided Token are then used to construct and return a new Amount object.
 * NOTE: this performs the necessary truncation so that the resultant amount contains a valid number of
 * decimal places for the target network.
 */
function newAmountFromDecimal(amount, token) {
    return new amount_pb_1.FutureAmount()
        .setValue((0, num_1.bigNumberToDecimal)((0, num_1.decimalToBigNumber)(amount).decimalPlaces((0, network_1.getNetworkNoDecimalPlaces)(token.getNetwork()), bignumber_js_1.default.ROUND_HALF_DOWN)))
        .setToken(token);
}
exports.newAmountFromDecimal = newAmountFromDecimal;
